module.exports = __webpack_public_path__ + "img/selected6-min.e69ccb37.png";